




import Enumerable from "linq";
import { Component, Mixins, Prop, } from "vue-property-decorator";
import OptionDropDownSelector from "../system/selectors/OptionDropDownSelector.vue";
import { ModelEditableMixin, DisableableMixin } from "../system/mixins";
import { StandardOption } from "../system/selectors/mixins";

@Component({
  components: {
    selector: OptionDropDownSelector,
  },
})
export default class LineWidthDropDownSelector extends Mixins(ModelEditableMixin, DisableableMixin) {
  @Prop()
  alternativeOptions: StandardOption<any>[];

  get dropDownOptions(): StandardOption<any>[] {
    return this.alternativeOptions
      ? this.alternativeOptions
      : Enumerable.from([
        1,
        2,
        3,
        4,
        5,
      ]).select(i => new StandardOption<number>(i + "px", i)).toArray();
  }
}
